

const defaultRegion = "Arizona";

export const defaultState = {
  mapsData: {},
  regionsData: [],
  scoresData: [],
  outcomeData: [],
  outcomeToolBarData: {},
  singleData: null,
  regionSelected: defaultRegion,
};

function Screen1Reducer(state = defaultState, action) {
  switch (action.type) {
    case "GET_MAPS_DATA":
      return { ...state, mapsData: action.payload };
    case "GET_REGIONS_DATA":
      return { ...state, regionsData: action.payload };
    case "GET_SCORES_DATA":
      return { ...state, scoresData: action.payload };
    case "GET_OUTCOME_DATA":
      return {
        ...state,
        outcomeData: action.payload[0],
        outcomeToolBarData: action.payload[1],
      };
    case "GET_DEMOGRAPHIC_DATA":
      return {
        ...state,
        raceData: action.payload[0],
        ageData: action.payload[1],
      };
    case "SET_SELECTED_REGION":
      return { ...state, regionSelected: action.payload };
    default:
      return state;
  }
}

export default Screen1Reducer;
